module.exports = __webpack_public_path__ + "static/img/GR.4b94dea0.jpg";